import type { Service } from "@raskrask-dk/raskrask-utils";
import type PackageState from "..";
import {Action} from "../../../action/action";

const SET_SERVICE = "SET_SERVICE";

export class SetService extends Action<typeof SET_SERVICE, Service> {
  readonly type = SET_SERVICE;
  protected state: PackageState;

  constructor(state: PackageState, service?: Service) {
    super(state, service);
    this.state = state;
  }

  public isValid(): boolean {
    if (!this.data) return true;
    if (!this.isDoable()) return false;
    const {goal} = this.state.getData();
    if (!goal) return false;
    const isGoalHasServiceType = goal.services.some((service) => service.id == this.data.id);
    return isGoalHasServiceType;
  }

  public isDoable(): boolean {
    const {goal} = this.state.getData();
    const isRequiredValuesSet = this.allHasValues(goal);
    return isRequiredValuesSet;
  }
}
